import React from 'react';
import { Sparkles, Zap } from 'lucide-react';
import AstronautMascot from './AstronautMascot';

const About = () => {
  const features = [
    {
      icon: Sparkles,
      title: 'Premium Quality',
      description: 'Only the finest ingredients make it into our cosmic creations'
    },
    {
      icon: Zap,
      title: 'Fast Service',
      description: 'Quick as a rocket launch - fresh hot dogs in minutes'
    }
  ];

  return (
    <section id="about" className="py-24 px-6 bg-gradient-to-b from-black to-gray-900 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-orange-500/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-cyan-400/5 rounded-full blur-3xl"></div>
      
      {/* Floating mascot */}
      <div className="absolute top-20 right-10 opacity-10 hidden lg:block">
        <AstronautMascot className="w-48 h-48" animated={true} />
      </div>

      <div className="max-w-6xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Our <span className="text-orange-500">Mission</span>
          </h2>
          <div className="w-24 h-1 bg-cyan-400 mx-auto mb-8"></div>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Born from a passion for incredible food and a love for all things cosmic, Sauce Dogz is redefining street food. 
            We're not just serving hot dogs – we're launching a culinary experience that transports your taste buds to another dimension.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mt-16">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div 
                key={index}
                className="group p-8 rounded-2xl bg-gradient-to-br from-gray-800/50 to-gray-900/50 border border-gray-700 hover:border-orange-500/50 transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-orange-500/10"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center mb-6 group-hover:rotate-6 transition-transform duration-300">
                  <Icon className="w-8 h-8 text-white" strokeWidth={2} />
                </div>
                <h3 className="text-2xl font-bold text-white mb-3">{feature.title}</h3>
                <p className="text-gray-400 leading-relaxed">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;